import React from 'react';
import { components as reactSelectComponents } from 'react-select';

export const CustomDropdownIndicator = ({ ...props }) => {
  return (
    <reactSelectComponents.DropdownIndicator {...props}>
      <span className="select__arrow" />
    </reactSelectComponents.DropdownIndicator>
  );
};
